import { DocumentNode, gql } from '@apollo/client';
import { HStack, Link, MenuItem, chakra } from '@chakra-ui/react';
import * as React from 'react';

import { AddToCalendarMenuItems_EventFragment } from './graphql-types/AddToCalendarMenuItems_EventFragment';

import { useAddToCalendarLink } from '../hooks/useAddToCalendarLink';
import { AppleIcon, GoogleIcon, OutlookIcon } from '../icons';

export const AddToCalendarMenuItems: React.FC<{
  communityName: string;
  hostnameAndProtocol: string;
  event: AddToCalendarMenuItems_EventFragment;
}> & {
  eventFragment: DocumentNode;
} = (props) => {
  const { calendarLinkSpecificForGoogle, calendarLink } = useAddToCalendarLink(
    props.communityName,
    props.hostnameAndProtocol,
    props.event
  );
  return (
    <>
      <MenuItem>
        <Link href={calendarLinkSpecificForGoogle} isExternal>
          <HStack>
            <GoogleIcon boxSize="5" />
            <chakra.span>Google Calendar</chakra.span>
          </HStack>
        </Link>
      </MenuItem>

      <MenuItem>
        <Link href={calendarLink} download={`${props.event.name}.ics`}>
          <HStack>
            <OutlookIcon boxSize="5" />
            <chakra.span>Outlook Calendar</chakra.span>
          </HStack>
        </Link>
      </MenuItem>

      <MenuItem>
        <Link href={calendarLink} download={`${props.event.name}.ics`}>
          <HStack>
            <AppleIcon boxSize="5" />
            <chakra.span>Apple Calendar</chakra.span>
          </HStack>
        </Link>
      </MenuItem>
    </>
  );
};

AddToCalendarMenuItems.eventFragment = gql`
  fragment AddToCalendarMenuItems_EventFragment on EventV2 {
    _id
    ...UseAddToCalendarLink_EventFragment
  }
  ${useAddToCalendarLink.eventFragment}
`;
